var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGaming = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Video-Game-Controller-Wifi--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Video Game Controller Wifi Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.58 5.07a10.51 10.51 0 0 1 14.84 0 1 1 0 0 0 1.42 0 1 1 0 0 0 0 -1.41 12.51 12.51 0 0 0 -17.68 0 1 1 0 0 0 0 1.41 1 1 0 0 0 1.42 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 7.9a1 1 0 0 0 0 -1.41 8.5 8.5 0 0 0 -12 0A1 1 0 0 0 7.4 7.9a6.52 6.52 0 0 1 9.2 0 1 1 0 0 0 1.4 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82 9.31a1 1 0 0 0 0 1.42 1 1 0 0 0 1.41 0 2.5 2.5 0 0 1 3.54 0 1 1 0 0 0 1.41 0 1 1 0 0 0 0 -1.42 4.51 4.51 0 0 0 -6.36 0Z",
    fill: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.78 13.56H5.22a5.22 5.22 0 0 0 0 10.44 5 5 0 0 0 3.34 -1.25 1.48 1.48 0 0 1 1 -0.37h4.92a1.48 1.48 0 0 1 1 0.37 5 5 0 0 0 3.3 1.25 5.22 5.22 0 0 0 0 -10.44Zm-11.67 6h-0.75a0.5 0.5 0 0 0 -0.5 0.5v0.75a0.75 0.75 0 0 1 -1.5 0V20a0.5 0.5 0 0 0 -0.5 -0.5h-0.75a0.75 0.75 0 1 1 0 -1.5h0.75a0.5 0.5 0 0 0 0.5 -0.5v-0.75a0.75 0.75 0 0 1 1.5 0v0.75a0.5 0.5 0 0 0 0.5 0.5h0.75a0.75 0.75 0 0 1 0 1.5Zm9.39 0.36a1.11 1.11 0 1 1 1.11 -1.11 1.11 1.11 0 0 1 -1.11 1.08Zm2.4 2.4a1.11 1.11 0 1 1 1.1 -1.14 1.11 1.11 0 0 1 -1.1 1.11Zm0 -4.8a1.11 1.11 0 1 1 1.1 -1.14 1.11 1.11 0 0 1 -1.1 1.11Zm2.4 2.4a1.11 1.11 0 1 1 1.11 -1.11 1.11 1.11 0 0 1 -1.11 1.08Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGaming);
export default ForwardRef;